var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hello screen-spacing pb-5" },
    [
      _c("h1", [_vm._v("Menu")]),
      _c("SelectVenue", {
        ref: "venueDropDown",
        on: { updateVenue: _vm.updateVenue },
      }),
      _vm.venue_id != 0
        ? _c("div", { staticClass: "mt-4" }, [
            _vm.canEditMenu
              ? _c(
                  "ul",
                  {
                    staticClass:
                      "nav custom-tabs mb-3 border-dark border-bottom border-1",
                    attrs: { role: "tablist" },
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: { role: "presentation" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.activeTab === "header" },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "header"
                              },
                            },
                          },
                          [_vm._v(" Manage Headers ")]
                        ),
                      ]
                    ),
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: { role: "presentation" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.activeTab === "menu" },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "menu"
                              },
                            },
                          },
                          [_vm._v(" Manage Menu ")]
                        ),
                      ]
                    ),
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: { role: "presentation" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.activeTab === "import" },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "import"
                              },
                            },
                          },
                          [_vm._v(" Import Menu ")]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.activeTab === "header"
              ? _c("div", [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mb-3",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleAddHeader },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              this.addHeaderToggle
                                ? "Cancel Add"
                                : "Add New Header"
                            ) +
                            " "
                        ),
                      ]
                    ),
                    this.addHeaderToggle
                      ? _c("div", [
                          _c(
                            "label",
                            {
                              staticClass: "me-2 h4 mt-3 screen-spacing",
                              attrs: { for: "dropdown" },
                            },
                            [_vm._v("Add New Header:")]
                          ),
                          _c("div", { staticClass: "input-group my-2" }, [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isLocationSpecific,
                                    expression: "isLocationSpecific",
                                  },
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "flexCheckDefault",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.isLocationSpecific)
                                    ? _vm._i(_vm.isLocationSpecific, null) > -1
                                    : _vm.isLocationSpecific,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isLocationSpecific,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isLocationSpecific = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isLocationSpecific = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isLocationSpecific = $$c
                                    }
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "flexCheckDefault" },
                                },
                                [_vm._v(" Is location specific? ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "tooltip-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.alertLocationInfo()
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "question-mark" }, [
                                    _vm._v("?"),
                                  ]),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "ms-3" },
                              [
                                _vm.venue_id != "" &&
                                _vm.venue_id != "0" &&
                                _vm.isLocationSpecific
                                  ? _c("SelectBar", {
                                      ref: "barDropDown",
                                      staticClass: "mb-3",
                                      attrs: {
                                        venueId: _vm.venue_id,
                                        liveOrder: true,
                                        includeHeader: false,
                                      },
                                      on: { updateBar: _vm.updateBar },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "input-group mb-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newHeader,
                                  expression: "newHeader",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Enter header name",
                              },
                              domProps: { value: _vm.newHeader },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.newHeader = $event.target.value
                                },
                              },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.tax_percentage,
                                  expression: "tax_percentage",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "number",
                                placeholder: "Tax %",
                                min: "0",
                                step: "1",
                              },
                              domProps: { value: _vm.tax_percentage },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.tax_percentage = $event.target.value
                                },
                              },
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: { click: _vm.saveHeader },
                              },
                              [_vm._v(" Save ")]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "mb-3" }, [
                      _c("h5", [_vm._v("Headers")]),
                      _vm.itemHeaders.length === 0
                        ? _c(
                            "p",
                            { staticClass: "text-muted fst-italic mt-3" },
                            [
                              _vm._v(
                                "No headers available. Add one above to get started."
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap gap-2" },
                        _vm._l(_vm.itemHeaders, function (header) {
                          return _c("h4", { key: header._id }, [
                            _c(
                              "button",
                              {
                                class: ["btn", "badge"],
                                attrs: { disabled: "" },
                              },
                              [_vm._v(" " + _vm._s(header.name) + " ")]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.toggleEditHeaders },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                this.editHeaders
                                  ? "Cancel Edit"
                                  : "Update Headers"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _vm.editHeaders
                      ? _c(
                          "div",
                          [
                            _vm._l(
                              _vm.itemHeaders,
                              function (header, itemHeaderIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: "header_" + itemHeaderIndex,
                                    staticClass: "header-group w-100 mt-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border-dark border-bottom border-2",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: header.name,
                                              expression: "header.name",
                                            },
                                          ],
                                          staticClass:
                                            "form-control d-inline-block w-25",
                                          attrs: { type: "text" },
                                          domProps: { value: header.name },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                header,
                                                "name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: header.tax_percentage,
                                              expression:
                                                "header.tax_percentage",
                                            },
                                          ],
                                          staticClass:
                                            "form-control d-inline-block w-25 ms-2",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Tax %",
                                          },
                                          domProps: {
                                            value: header.tax_percentage,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                header,
                                                "tax_percentage",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "form-check my-2" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    header.is_location_specific,
                                                  expression:
                                                    "header.is_location_specific",
                                                },
                                              ],
                                              staticClass: "form-check-input",
                                              attrs: {
                                                type: "checkbox",
                                                id: "flexCheckDefault",
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  header.is_location_specific
                                                )
                                                  ? _vm._i(
                                                      header.is_location_specific,
                                                      null
                                                    ) > -1
                                                  : header.is_location_specific,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      header.is_location_specific,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          header,
                                                          "is_location_specific",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          header,
                                                          "is_location_specific",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      header,
                                                      "is_location_specific",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form-check-label",
                                                attrs: {
                                                  for: "flexCheckDefault",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Is location specific? "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.venue_id != "" &&
                                        _vm.venue_id != "0" &&
                                        header.is_location_specific
                                          ? _c("SelectBar", {
                                              ref:
                                                "barDropDown" + itemHeaderIndex,
                                              refInFor: true,
                                              staticClass: "mb-3",
                                              attrs: {
                                                loadBar: _vm.editHeaders,
                                                venueId: _vm.venue_id,
                                                loadValue: header.location_ID,
                                                liveOrder: true,
                                                includeHeader: false,
                                              },
                                              on: {
                                                updateBar: function ($event) {
                                                  return _vm.updateBarInArray(
                                                    $event,
                                                    itemHeaderIndex
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mt-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateAllHeaders()
                                  },
                                },
                              },
                              [_vm._v(" Save ")]
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm.activeTab === "menu"
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "mb-3" }, [
                        _c("h5", [_vm._v("Headers")]),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-wrap gap-2" },
                          _vm._l(_vm.itemHeaders, function (header) {
                            return _c(
                              "button",
                              {
                                key: header._id + "-filter",
                                class: [
                                  "btn",
                                  "btn-sm",
                                  "rounded-pill",
                                  _vm.isHeaderActive(header._id)
                                    ? "btn-dark text-white"
                                    : "btn-outline-secondary",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleHeaderFilter(header._id)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(header.name) + " ")]
                            )
                          }),
                          0
                        ),
                      ]),
                      _c("div", { staticClass: "mb-3" }, [
                        _c("h5", [_vm._v("Item Search")]),
                        _c(
                          "div",
                          {
                            staticClass: "input-group mb-3",
                            staticStyle: { "max-width": "300px" },
                          },
                          [
                            _vm._m(0),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchQuery,
                                  expression: "searchQuery",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Search by name of item",
                              },
                              domProps: { value: _vm.searchQuery },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.searchQuery = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._l(_vm.enrichHeaders, function (header, headerIndex) {
                        return _c(
                          "div",
                          {
                            key: "header_" + headerIndex,
                            staticClass: "header-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "h3 header-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2",
                                attrs: { for: "for_" + header },
                              },
                              [
                                _vm._v(_vm._s(header.name) + " "),
                                _vm.isBusiness
                                  ? _c(
                                      "button",
                                      {
                                        ref: "action",
                                        refInFor: true,
                                        staticClass:
                                          "btn btn-outline-primary btn-outline-pulse ms-2",
                                        attrs: {
                                          type: "button",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#newItemModal",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openModal(
                                              header.name,
                                              "Add " + header.name,
                                              header
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Add Item")]
                                    )
                                  : _vm._e(),
                                _vm.isBusiness
                                  ? _c(
                                      "button",
                                      {
                                        ref: "action",
                                        refInFor: true,
                                        staticClass:
                                          "btn btn-outline-primary btn-outline-pulse ms-2",
                                        attrs: {
                                          type: "button",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#newModifierModal",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openModifierModal(header)
                                          },
                                        },
                                      },
                                      [_vm._v("Add Modifier")]
                                    )
                                  : _vm._e(),
                                _vm.isBusiness
                                  ? _c(
                                      "button",
                                      {
                                        ref: "action",
                                        refInFor: true,
                                        staticClass:
                                          "btn btn-outline-warning ms-2",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleAllVip(
                                              header._id,
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Mark All VIP")]
                                    )
                                  : _vm._e(),
                                _vm.isBusiness
                                  ? _c(
                                      "button",
                                      {
                                        ref: "action",
                                        refInFor: true,
                                        staticClass:
                                          "btn btn-outline-secondary ms-2",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleAllVip(
                                              header._id,
                                              false
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Clear VIP")]
                                    )
                                  : _vm._e(),
                                _vm.isBusiness
                                  ? _c(
                                      "button",
                                      {
                                        ref: "action",
                                        refInFor: true,
                                        staticClass:
                                          "btn btn-outline-danger btn-outline-delete ms-2",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteHeader(header)
                                          },
                                        },
                                      },
                                      [_vm._v("Delete Header")]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  header.tax_percentage
                                    ? `Tax : ${header.tax_percentage}%`
                                    : ""
                                )
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  header.is_location_specific
                                    ? _vm.getLocationName(header.location_ID)
                                    : ""
                                )
                              ),
                            ]),
                            header.modifiers.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "row mt-4" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2",
                                      },
                                      [_vm._v("Modifiers")]
                                    ),
                                    _vm._l(
                                      header.modifiers,
                                      function (modifier, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "modifier_" + index,
                                            staticClass: "card m-3",
                                            staticStyle: { width: "18rem" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-body" },
                                              [
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "card-title mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(modifier.name) +
                                                        " - " +
                                                        _vm._s(
                                                          modifier.isMultiSelection
                                                            ? "Multi"
                                                            : "Single"
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          modifier.is_item_specific
                                                            ? "- " +
                                                                _vm.menu.filter(
                                                                  (item) =>
                                                                    item._id ===
                                                                    modifier.relationship_ID
                                                                )[0].name
                                                            : ""
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm._l(
                                                  modifier.answer_list,
                                                  function (answer, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: "answer" + index,
                                                        staticClass: "m-2",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "card-text text-muted fs-6",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                answer.text
                                                              ) +
                                                                _vm._s(
                                                                  modifier.adjustsPayment
                                                                    ? "- $" +
                                                                        answer.cost
                                                                    : ""
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "btn-group",
                                                    attrs: { role: "group" },
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary me-2",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleEnableModifier(
                                                              modifier
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            modifier.is_disabled
                                                              ? "Disabled"
                                                              : "Enabled"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.isBusiness
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary me-2",
                                                            attrs: {
                                                              type: "button",
                                                              "data-bs-toggle":
                                                                "modal",
                                                              "data-bs-target":
                                                                "#newModifierModal",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openEditModifier(
                                                                  modifier,
                                                                  header
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Edit")]
                                                        )
                                                      : _vm._e(),
                                                    _vm.isBusiness
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary",
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteModifier(
                                                                  modifier
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Delete")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            header.items.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "row mt-4" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "h5 subheader-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2",
                                        attrs: { for: "for_" + header },
                                      },
                                      [_vm._v("Items")]
                                    ),
                                    _vm._l(
                                      header.items,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "item_" + index,
                                            staticClass: "card m-3",
                                            staticStyle: { width: "18rem" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-body" },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "card-picture-size",
                                                  attrs: {
                                                    src:
                                                      item.image ||
                                                      require("../../assets/No_Image.jpg"),
                                                    alt: item.name,
                                                  },
                                                }),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "card-title mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.name) +
                                                        " " +
                                                        _vm._s(
                                                          item.is_vip
                                                            ? "(VIP)"
                                                            : ""
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "card-text text-muted fs-6",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "$" + _vm._s(item.cost)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "card-text fixedTextBox",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.description == ""
                                                          ? "N/A"
                                                          : item.description
                                                              .length >= 120
                                                          ? item.description.slice(
                                                              0,
                                                              120
                                                            ) + "..."
                                                          : item.description
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "btn-group",
                                                    attrs: { role: "group" },
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary me-2",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleEnable(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.is_disabled
                                                              ? "Disabled"
                                                              : "Enabled"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.isBusiness
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary me-2",
                                                            attrs: {
                                                              type: "button",
                                                              "data-bs-toggle":
                                                                "modal",
                                                              "data-bs-target":
                                                                "#newItemModal",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openEditModal(
                                                                  item,
                                                                  "Cocktail"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Edit")]
                                                        )
                                                      : _vm._e(),
                                                    _vm.isBusiness
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary",
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteItem(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Delete")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm.activeTab === "import"
              ? _c("div", [
                  _vm.selectedJob === ""
                    ? _c("div", [
                        _c("div", { staticClass: "image-upload-section" }, [
                          _c("h3", [_vm._v("Import Menu Image")]),
                          _c("p", [
                            _vm._v(
                              " Please upload a clear image of your menu. Make sure the text is readable and properly lit. If the sections are formatted differently, upload separate images for each section. "
                            ),
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("input", {
                                staticClass: "form-control w-100",
                                attrs: {
                                  type: "file",
                                  accept: "image/*",
                                  id: "menuImageUpload",
                                },
                                on: { change: _vm.handleImageUpload },
                              }),
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btnAccent",
                                  on: { click: _vm.submitImage },
                                },
                                [_vm._v("Submit Image")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "tooltip-btn",
                                  attrs: { type: "button" },
                                  on: { click: _vm.submissionInfo },
                                },
                                [
                                  _c("span", { staticClass: "question-mark" }, [
                                    _vm._v("?"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "menu-job-list" }, [
                          _c("h3", [_vm._v("Current Menu Jobs")]),
                          _c("table", { staticClass: "table" }, [
                            _vm._m(1),
                            _c(
                              "tbody",
                              _vm._l(_vm.menuJobs, function (job) {
                                return _c("tr", { key: job._id }, [
                                  _c(
                                    "th",
                                    { attrs: { th: "", scope: "row" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          job.imageName ||
                                            job.result?.cafe_name ||
                                            "N/A"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        new Date(job.createdAt).toLocaleString()
                                      )
                                    ),
                                  ]),
                                  _c("td", [_vm._v(_vm._s(job.status))]),
                                  _c("td", [
                                    job.status === "complete"
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn btnAccent",
                                            on: {
                                              click: function ($event) {
                                                return _vm.setSelectedJob(job)
                                              },
                                            },
                                          },
                                          [_vm._v(" Import Menu ")]
                                        )
                                      : job.status === "error"
                                      ? _c("span", [_vm._v("Error")])
                                      : _vm._e(),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ]),
                      ])
                    : _c(
                        "div",
                        [
                          _c("MenuEdit", {
                            attrs: {
                              jobData: _vm.selectedJob,
                              venue_id: _vm.venue_id,
                            },
                            on: { goBack: _vm.goBack },
                          }),
                        ],
                        1
                      ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          ref: "modal",
          staticClass: "modal fade",
          attrs: {
            id: "newItemModal",
            tabindex: "-1",
            "aria-labelledby": "newbathroomModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "NewMenuItem",
            {
              attrs: {
                itemType: _vm.newItemType,
                currentHeaderUpdate: _vm.currentHeaderUpdate,
                venue_id: _vm.venue_id,
                editItem: _vm.editItem,
              },
              on: {
                addItem: _vm.addItem,
                updateItem: _vm.updateItem,
                clearEdit: _vm.clearEdit,
              },
            },
            [_vm._v(" " + _vm._s(_vm.displayedModalString) + " ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "modal",
          staticClass: "modal fade",
          attrs: {
            id: "newModifierModal",
            tabindex: "-1",
            "aria-labelledby": "newbathroomModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "AddModifier",
            {
              attrs: {
                venue_id: _vm.venue_id,
                currentHeaderUpdate: _vm.currentHeaderUpdate,
                currentItems: _vm.currentItems,
                editmodifier: _vm.editmodifier,
              },
              on: {
                addNewModifier: _vm.addNewModifier,
                updateModifier: _vm.updateModifier,
                clearEdit: _vm.clearEdit,
              },
            },
            [_vm._v(" " + _vm._s(_vm.displayedModifierString) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "ph-bold ph-magnifying-glass" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Created At")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Status")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }